(function() {
  var __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  $(document).foundation();

  $(document).ready(() => {

    const initMailPopUp = function () {
      // Never fire on bundle pages — the welcome code excludes bundles, so a popup
      // there would mismatch checkout. Returning early does NOT consume the 14-day
      // cooldown or the per-session flag, so it can still fire once the shopper
      // navigates to another (non-bundle) page.
      if (document.body && document.body.className.indexOf('template-product-bundle') !== -1) return;

      const COOLDOWN_DAYS = 14;
      const COOLDOWN_MS = COOLDOWN_DAYS * 24 * 60 * 60 * 1000;
      const isSubscribed = localStorage.getItem('undrgrnd-subscriber');
      const dismissedAt = parseInt(localStorage.getItem('undrgrnd-popup-dismissed'), 10);
      const recentlyDismissed = !isNaN(dismissedAt) && (Date.now() - dismissedAt) < COOLDOWN_MS;
      const sessionVisitor = JSON.parse(sessionStorage.getItem('undrgrnd-visitor'));
      const showPopUp = !isSubscribed && !recentlyDismissed && !sessionVisitor;
      const body = $('body');
      const POPUPDELAY = 5000;

      // Persist a 14-day cooldown the moment the popup is shown, so a non-subscriber
      // who closes or ignores it won't see it again across sessions until it expires.
      const markDismissed = function () {
        try { localStorage.setItem('undrgrnd-popup-dismissed', Date.now().toString()); } catch (e) {}
      };

      const openPopUp = function (modal) {
          modal.fadeIn();
          modal.css('top', $(window).scrollTop());
          body.css('overflow', 'hidden');
          markDismissed();
      }

      const closePopUp = function (modal) {
        modal.hide();
        body.css('overflow', 'scroll');
        markDismissed();
      }

      if (showPopUp) {
        sessionStorage.setItem('undrgrnd-visitor', JSON.stringify(true));
        const popUpModal = $('.pop-up-modal');
        const closeButton = $('.pop-up-close');

        closeButton.on('click', function () {
          closePopUp(popUpModal);
        });

        setTimeout(function () {
          openPopUp(popUpModal);
        }, POPUPDELAY);
      }

      // Bind once — initMailPopUp can be re-invoked on instant-nav page views.
      if (!window.__ugMailFormBound) {
        window.__ugMailFormBound = true;
        $('form[name="mc-embedded-subscribe-form"]').submit((e) => {
          const validInputFields = ['LNAME', 'FNAME', 'EMAIL'];

          const inputs = $(e.target).find('input');
          let areAllFieldsValid = true;
          inputs.each((i, input) => {
            const fieldName = $(input).attr('name');
            if (validInputFields.indexOf(fieldName) >= 0 && !$(input).hasClass('valid')) {
              areAllFieldsValid = false;
            }
          });
          if (areAllFieldsValid) {
            localStorage.setItem('undrgrnd-subscriber', JSON.stringify(true));
          }
        });
      }
    }

    // Expose so instant navigation (Swup) can re-evaluate the popup after the
    // shopper moves off a bundle page onto an eligible one.
    window.ugMaybeShowWelcomePopup = initMailPopUp;
    initMailPopUp();

  });

  jQuery(function($) {
    var FullscreenSlider, HEADER, PAGE, VideoModal, addToCart, addToCartFail, addToCartPass, cart_dropdown_timer, current_window, fadeOutCartDropdown, first_article_img, fullscreen_slider, imgZoom, instagramFeed, isFirefox, log, mainMenu, mediaQueries, mobileMenu, mq_large, mq_medium, mq_small, openMobileModal, page_content, photos, pinterest_button, positions, productModal, productSlider, recentCartItemPopUp, searchAndAccount, slideDownCartDropdown, smallPromos, startTimer, stickyFooter, stopResetTimer, thumbs, toggleCartDropdown, updateActiveImg, validateSize;
    PAGE = $('body');
    HEADER = $('.main-header');
    mq_small = 768;
    mq_medium = 1280;
    mq_large = 1440;
    log = function(value) {
      if (typeof console !== "undefined") {
        return console.log(value);
      }
    };
    stickyFooter = function() {
      var total_content_height;
      total_content_height = $('.main-header').outerHeight() + $('.main-content').outerHeight() + $('.main-footer').outerHeight();
      if ($(window).outerHeight() > total_content_height) {
        return $('.main-content').css({
          'min-height': $(window).outerHeight() - $('.main-header').outerHeight() - $('.main-footer').outerHeight()
        });
      }
    };
    stickyFooter();
    $(window).resize(function () {
      return stickyFooter();
    });
    if (general_external_links_enabled) {
      $('a[href^="http"]').not('a[href^="' + shop_url + '"]').attr('target', '_blank');
    }
    searchAndAccount = function() {
      $('.searchbar-open').click(function() {
        $('.cart-container').fadeOut(100);
        $(this).closest('.menu').fadeOut(100, function() {
          $('.search-account').addClass('search-open');
          $('.main-header .searchbar-container').fadeIn(200);
          return $('.main-header .searchbar-container .search-box').focus();
        });
        return false;
      });
      $('.searchbar-close').click(function () {
        $('.search-account').removeClass('search-open');
        $('.main-header .searchbar-container').fadeOut(100, function() {
          $('.cart-container').fadeIn(200);
          return $('.search-account .menu').fadeIn(200);
        });
        return false;
      });
      $('.account-open').click(function() {
        $('.cart-container').fadeOut(100);
        $(this).closest('.menu').fadeOut(100, function() {
          $('.search-account').addClass('account-open');
          return $('.account-container').fadeIn(200);
        });
        return false;
      });
      return $('.account-close').click(function() {
        $('.search-account').removeClass('account-open');
        $('.account-container').fadeOut(100, function() {
          $('.cart-container').fadeIn(200);
          return $('.search-account .menu').fadeIn(200);
        });
        return false;
      });
    };
    searchAndAccount();
    mainMenu = function() {
      var container, dropdown_panel, links, main_header, main_menu_dropdown_timer, slideUpPanel, startTimer, stopResetTimer;
      dropdown_panel = $(".main-menu-dropdown-panel .wrapper");
      main_header = $(".template-index .main-header");
      container = $('.main-header .menu-container');
      links = container.find('.nav-item').has('.sub-nav').addClass('dropdown').find('> a');
      links.append('<span aria-hidden="true" class="glyph arrow-down"></span>');
      container.find('.nav-item').has('.sub-nav ul').find('.columns').addClass('large-3');
      container.find('.nav-item').has('.sub-nav ul').find('.columns > a > span').wrap('<h3 class="title"></div>');
      HEADER.find(".main-menu .widescreen .dropdown > a").click(function(e) {
        var autoHeight, curHeight, dropdown, sub_nav;
        var newHeader = $('.new-header');
        var link = $(this);
        dropdown = $(this).parent();
        function positionDropDown(dropDown) {
          var linkCenterPosition = link.offset().left + (link.width() / 2);
          var dropDownHalfWidth = dropdown_panel.width() / 2;
          dropdown_panel.parent().css('left', linkCenterPosition - dropDownHalfWidth);
        }
        positionDropDown();
        $(window).resize(function () {
          if (dropdown.hasClass("active")) {
            positionDropDown();
          }
        })
        sub_nav = dropdown.find(".sub-nav .columns");
        if (PAGE.hasClass('template-index') && PAGE.hasClass('transparent-menu') && Modernizr.touch) {
          if ($('.main-header').hasClass('dropdown-open')) {
            if (dropdown.hasClass("active")) {
              startTimer();
            }
          } else {
            $('.main-header .bg').fadeIn();
          }
        }
        if (dropdown.hasClass("active")) {
          slideUpPanel();
        } else if ($('.main-header').hasClass('dropdown-open')) {
          dropdown_panel.find(".columns").animate({
            opacity: 0
          }, 200);
          dropdown_panel.find('.columns').remove();
          HEADER.find(".main-menu .dropdown").removeClass('active');
          dropdown.addClass("active");
          sub_nav.clone().appendTo(".main-menu-dropdown-panel .row");
          dropdown_panel.find(".columns").delay(200).animate({
            opacity: 1
          }, 200);
          curHeight = dropdown_panel.height();
          autoHeight = dropdown_panel.css('height', 'auto').outerHeight();
          dropdown_panel.height(curHeight).animate({
            height: autoHeight
          }, 400);
        } else {
          dropdown_panel.find('.columns').remove();
          $('.main-header').addClass('dropdown-open');
          dropdown.addClass("active");
          sub_nav.clone().appendTo(".main-menu-dropdown-panel .wrapper");
          dropdown_panel.slideDown(400, function() {
            return dropdown_panel.css("height", dropdown_panel.outerHeight());
          });
          dropdown_panel.find(".columns").delay(200).animate({
            opacity: 1
          }, 200);
        }
        return false;
      });
      slideUpPanel = function() {
        $('.main-header').removeClass('dropdown-open');
        HEADER.find(".main-menu .dropdown").removeClass('active');
        dropdown_panel.find(".columns").animate({
          opacity: 0
        }, 200);
        return dropdown_panel.delay(200).slideUp(function() {
          dropdown_panel.find('.columns').remove();
          return dropdown_panel.css('height', 'auto');
        });
      };
      main_menu_dropdown_timer = '';
      startTimer = function() {
        return main_menu_dropdown_timer = setTimeout((function() {
          slideUpPanel();
          if (PAGE.hasClass('template-index') && PAGE.hasClass('transparent-menu')) {
            return $('.main-header .bg').delay(300).fadeOut();
          }
        }), 500);
      };
      return stopResetTimer = function() {
        return clearTimeout(main_menu_dropdown_timer);
      };
    };
    mainMenu();
    mobileMenu = function() {
      var dropdown_links, mobile_menu, mobile_menu_link;
      mobile_menu_link = $('.mobile-tools .menu');
      mobile_menu = $('.mobile-menu');
      mobile_menu.find('.nav-item').has('.sub-nav').find('> .nav-item-link').addClass('dropdown-link');
      mobile_menu.find('.nav-item').has('.sub-nav').find('> .nav-item-link').append('<span aria-hidden="true" class="glyph plus"></span><span aria-hidden="true" class="glyph minus"></span>');
      mobile_menu.find('.nav-item').has('.sub-nav ul').find('.columns > a > span').css('text-transform', 'uppercase');
      dropdown_links = mobile_menu.find("a.dropdown-link");
      mobile_menu_link.click(function() {
        mobile_menu.toggle();
        return false;
      });
      return dropdown_links.click(function() {
        var sub_menu;
        sub_menu = $(this).closest('li').find('.sub-nav:eq(0)');
        sub_menu.slideToggle();
        $(this).find('.glyph.plus').toggle();
        $(this).find('.glyph.minus').toggle();
        return false;
      });
    };
    mobileMenu();
    instagramFeed = function() {
      var access_token, getImages, items_to_load, username;
      access_token = home_widget_instagram_access_token;
      username = $('.instagram-widget').attr('data-username');
      if (access_token.length < 1 || $('.instagram-widget').length < 1 || username.length < 1) {
        return false;
      }
      items_to_load = 6;
      if (!home_widget_twitter_enabled && !home_widget_blog_enabled) {
        items_to_load += 6;
        $('.instagram-widget .items').addClass('wide');
      }
      getImages = function() {
        return $.ajax({
          dataType: "jsonp",
          url: 'https://api.instagram.com/v1/users/self/media/recent/?access_token=' + access_token + '&count=' + items_to_load,
          success: function(response) {
            var data, i, img_src, _i, _ref, _results;
            if (response.meta.code === 200) {
              data = response.data;
              _results = [];
              for (i = _i = 0, _ref = items_to_load - 1; 0 <= _ref ? _i <= _ref : _i >= _ref; i = 0 <= _ref ? ++_i : --_i) {
                if (data[i]) {
                  img_src = data[i].images.low_resolution.url;
                  img_src = img_src.replace("http:", "https:");
                  _results.push($('.instagram-widget .items').append('<a class="item" target="_blank" href="' + data[i].link + '"><img src="' + img_src + '" /></a>'));
                } else {
                  _results.push(void 0);
                }
              }
              return _results;
            } else {
              return $('.instagram-widget .items').append('<p class="error">' + response.meta.error_message + '</p><p class="colored-links">Check the <strong>Homepage - social feeds</strong> section in your <a target="_blank" href="/admin/themes">theme settings</a>.</p>');
            }
          },
          error: function(jqXHR, textStatus) {
            console.log(jqXHR);
            return console.log(textStatus);
          }
        });
      };
      return getImages();
    };
    VideoModal = (function() {
      function VideoModal(video) {
        this.createIframe = __bind(this.createIframe, this);
        this.extractVideoId = __bind(this.extractVideoId, this);
        this.extractVideoType = __bind(this.extractVideoType, this);
        this.eventListeners = __bind(this.eventListeners, this);
        this.centerPosition = __bind(this.centerPosition, this);
        this.close = __bind(this.close, this);
        this.open = __bind(this.open, this);
        this.opened = false;
        this.video = video;
        this.modal = $('.video.modal');
        this.player_button = video.find('.player-button');
        this.src_url = video.find('.play-button').attr('href');
        this.type = this.extractVideoType();
        this.id = this.extractVideoId();
        this.iframe = this.createIframe();
        this.caption = video.find('.caption');
      }

      VideoModal.prototype.open = function() {
        this.opened = true;
        this.modal.find(".flex-video").append(this.iframe);
        if (this.caption.length > 0) {
          this.modal.find(".caption").append(this.caption.html());
          this.modal.addClass("wide");
        } else {
          this.modal.find(".player").removeClass('large-8');
          this.modal.find('.caption').hide();
          this.modal.removeClass("wide");
        }
        this.player_button.hide();
        $('.modal-mask').show();
        this.modal.find('.close').show();
        this.modal.fadeIn();
        this.centerPosition();
        $(".modal").fadeIn(0);
        return this.eventListeners();
      };

      VideoModal.prototype.close = function() {
        this.opened = false;
        this.modal.find(".flex-video").empty();
        this.modal.find(".caption").empty();
        this.modal.hide();
        $('.modal-mask').fadeOut();
        if (this.caption.length === 0) {
          this.modal.find(".player").addClass('large-8');
          return this.modal.find('.caption').show();
        }
      };

      VideoModal.prototype.centerPosition = function() {
        if ($(window).height() < this.modal.outerHeight()) {
          return this.modal.css({
            'position': 'absolute',
            'top': '30px',
            'margin-top': 0,
            'margin-left': -(this.modal.outerWidth() / 2)
          });
        } else {
          return this.modal.css({
            'position': 'fixed',
            'top': '50%',
            'margin-top': -(this.modal.outerHeight() / 2),
            'margin-left': -(this.modal.outerWidth() / 2)
          });
        }
      };

      VideoModal.prototype.eventListeners = function() {
        var modal;
        modal = this;
        this.modal.find('.close').on('click', function() {
          return modal.close();
        });
        $(window).resize(function() {
          return modal.centerPosition();
        });
        $(document).keydown(function(e) {
          if (modal.opened) {
            if (e.keyCode === 27) {
              return modal.close();
            }
          }
        });
        $('.modal-mask').on('click', function() {
          return modal.close();
        });
        return this.player_button.on('click', function() {
          return false;
        });
      };

      VideoModal.prototype.extractVideoType = function() {
        var matches, re;
        re = /\/\/(?:www\.)?youtu(?:\.be|be\.com)\/(?:watch\?v=|embed\/)?([a-z0-9_\-]+)/i;
        matches = re.exec(this.src_url);
        if (matches) {
          return 'youtube';
        } else {
          re = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/;
          matches = re.exec(this.src_url);
          if (matches) {
            return 'vimeo';
          }
        }
        return false;
      };

      VideoModal.prototype.extractVideoId = function() {
        var match, regExp;
        if (this.type === 'youtube') {
          regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
          match = this.src_url.match(regExp);
          if (match && match[2].length === 11) {
            return match[2];
          }
        } else if (this.type === "vimeo") {
          regExp = /^.*(vimeo)\.com\/(?:watch\?v=)?(.*?)(?:\z|$|&)/;
          match = this.src_url.match(regExp);
          if (match) {
            return match[2];
          }
        }
      };

      VideoModal.prototype.createIframe = function() {
        if (this.type === "youtube") {
          return '<iframe  src="//www.youtube.com/embed/' + this.id + '?autoplay=1&rel=0" frameborder="0" allowfullscreen></iframe>';
        } else if (this.type === "vimeo") {
          return '<iframe src="//player.vimeo.com/video/' + this.id + '?title=0&amp;byline=0&amp;portrait=0&amp;color=ffffff&amp;autoplay=1?" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
        }
      };

      return VideoModal;

    })();
    productModal = function() {
      var changeModal, closeModal, modal, modal_controls, modal_init, modal_length, modal_open, openModal, resizeModal;
      modal = $('.modal');
      if ($('.modal').length && product_modal_enabled) {
        modal_length = $("article .photos .photo").length;
        modal_init = false;
        modal_open = false;
        modal.find('.loading').spin('small');
        if (modal_length > 1) {
          modal.addClass("with-nav");
          modal_controls = modal.find('.glyph');
        } else {
          modal_controls = modal.find('.close');
        }
        resizeModal = function() {
          var active_photo, height_ratio, image_height, image_width, width_ratio, window_height, window_width;
          active_photo = modal.find('.photo.active');
          image_width = active_photo.naturalWidth();
          image_height = active_photo.naturalHeight();
          window_width = $(window).width();
          window_height = $(window).height();
          width_ratio = image_width / window_width;
          height_ratio = image_height / window_height;
          if (width_ratio > height_ratio && width_ratio > .90) {
            image_width = image_width * .90 / width_ratio;
            image_height = image_height * .90 / width_ratio;
          } else if (width_ratio < height_ratio && height_ratio > .90) {
            image_width = image_width * .90 / height_ratio;
            image_height = image_height * .90 / height_ratio;
          }
          modal.css({
            'width': image_width,
            'height': image_height,
            'margin-top': -(image_height / 2),
            'margin-left': -(image_width / 2)
          });
          return active_photo.css({
            'height': image_height
          });
        };
        openModal = function(index) {
          var active_photo;
          modal_open = true;
          if (!modal_init) {
            $("article .photos .photo").each(function() {
              return modal.find(".slides").append($('<img />').attr('src', $(this).attr('href')).addClass('photo'));
            });
            modal_init = true;
          }
          $('.modal-mask').show();
          modal.fadeIn();
          active_photo = $(".modal img").eq(index);
          active_photo.addClass('active');
          return modal.find(".photo.active").imagesLoaded(function() {
            modal.find(".loading").hide();
            modal_controls.show();
            modal.find(".slides").show();
            return resizeModal();
          });
        };
        $('.photos .container').on('click', function(e) {
          if ($(e.target).closest('.ug-audio-play-trigger').length) {
            return;
          }
          var index;
          if (current_window === 'small') {
            return false;
          }
          index = $(this).find('.photo.active').index();
          return openModal(index);
        });
        closeModal = function() {
          modal_open = false;
          modal.find(".photo.active").removeClass("active");
          modal.css('display', 'none');
          return $('.modal-mask').fadeOut();
        };
        modal.find('.close').on('click', function() {
          return closeModal();
        });
        $('.modal-mask').on('click', function() {
          return closeModal();
        });
        changeModal = function(direction) {
          var active_index, active_photo, new_index, photo_length;
          active_photo = modal.find('.photo.active');
          active_index = modal.find('.photo.active').index();
          photo_length = modal.find('.photo').length;
          if (direction === 'prev') {
            if (active_index === 0) {
              new_index = photo_length - 1;
            } else {
              new_index = active_index - 1;
            }
          }
          if (direction === 'next') {
            if (active_index === photo_length - 1) {
              new_index = 0;
            } else {
              new_index = active_index + 1;
            }
          }
          active_photo.removeClass('active');
          modal_controls.hide();
          modal.find(".loading").delay(50).fadeIn(0);
          return modal.find('.photo').eq(new_index).imagesLoaded(function() {
            modal.find(".loading").stop(true, true).fadeOut(0);
            modal_controls.show();
            modal.find('.photo').eq(new_index).addClass('active');
            return resizeModal();
          });
        };
        modal.find('.prev').on('click', function() {
          return changeModal('prev');
        });
        modal.find('.next').on('click', function() {
          return changeModal('next');
        });
        modal.find('.slides').on('click', function() {
          return changeModal('next');
        });
        $(document).off('keydown.ugmodal').on('keydown.ugmodal', function(e) {
          if (modal_open) {
            if (e.keyCode === 37 && modal_length > 1) {
              changeModal('prev');
            }
            if (e.keyCode === 39 && modal_length > 1) {
              changeModal('next');
            }
            if (e.keyCode === 27) {
              return closeModal();
            }
          }
        });
        if (modal_init) {
          return $(window).resize(function() {
            return resizeModal();
          });
        }
      }
    };
    // Content widgets (accordions / tabs) live inside .main-content, so they must
    // be (re)initialised on each page — including after an instant-nav swap.
    // Guarded against double-wrapping in case it runs on already-processed DOM.
    function ugInitContentWidgets() {
    $('.accordion.headings').each(function() {
      if ($(this).closest('.accordion-wrapper').length) return;
      return $(this).add($(this).next('.accordion.content')).wrapAll("<div class='accordion-wrapper'/>");
    });
    $('.accordion.headings li').not(':has(> .trigger)').wrapInner('<div class="trigger"></div>');
    $('.accordion.headings li .trigger').not(':has(> .bg)').append('<div class="bg"></div>');
    $('.accordion-wrapper').each(function() {
      if ($(this).data('ugAccInit')) return;
      $(this).data('ugAccInit', true);
      var accordion_content, accordion_heading;
      accordion_heading = $(this).find('.accordion.headings > li');
      accordion_content = $(this).find('.accordion.content > li');
      accordion_heading.first().addClass('active');
      accordion_content.each(function(index) {
        var content;
        content = $('<div class="content">' + $(this).html() + '</div>');
        return content.appendTo(accordion_heading.eq(index));
      });
      accordion_content.remove();
      $(this).find('.content').first().show();
      return $(this).find('.trigger').on("click", function() {
        var panels, this_panel;
        panels = $(this).closest(".accordion").find('.content');
        this_panel = $(this).closest("li").find(".content");
        panels.not(this_panel).slideUp(200);
        this_panel.slideDown(200, function() {
          if (general_scroll_to_active_item) {
            return $('html, body').animate({
              scrollTop: this_panel.offset().top - 100
            });
          }
        });
        $(this).closest(".accordion").find("li").removeClass("active");
        return $(this).closest("li").addClass("active");
      });
    });
    $('.tabs-horizontal.headings').each(function() {
      if ($(this).closest('.tabs-wrapper').length) return;
      return $(this).add($(this).next('.tabs.content')).wrapAll("<div class='tabs-wrapper horizontal'/>");
    });
    $('.tabs-horizontal.headings li').not(':has(> .trigger)').wrapInner('<div class="trigger"></div>');
    $('.tabs-horizontal.headings li .trigger').not(':has(> .bg)').append('<div class="bg"></div>');
    $('.tabs-wrapper.horizontal').each(function() {
      if ($(this).data('ugTabInit')) return;
      $(this).data('ugTabInit', true);
      var tab_content, tab_headings;
      tab_headings = $(this).find('.headings > li');
      tab_content = $(this).find('.tabs.content > li');
      tab_content.first().addClass('active');
      tab_headings.first().addClass('active');
      return tab_headings.on('click', function() {
        tab_headings.removeClass('active');
        tab_content.removeClass('active');
        $(this).addClass('active');
        return tab_content.eq($(this).index()).addClass('active');
      });
    });
    $('.tabs-vertical.headings').each(function() {
      if ($(this).closest('.tabs-wrapper').length) return;
      return $(this).add($(this).next('.tabs.content')).wrapAll("<div class='tabs-wrapper vertical'/>");
    });
    $('.tabs-vertical.headings li').not(':has(> .trigger)').wrapInner('<div class="trigger"></div>');
    $('.tabs-vertical.headings li .trigger').not(':has(> .bg)').append('<div class="bg"></div>');
    $('.tabs-wrapper.vertical').each(function() {
      if ($(this).data('ugTabInit')) return;
      $(this).data('ugTabInit', true);
      var tab_content, tab_headings, tab_wrapper;
      tab_wrapper = $(this);
      tab_headings = $(this).find('.headings > li');
      tab_content = $(this).find('.tabs.content > li');
      tab_content.first().addClass('active');
      tab_headings.first().addClass('active');
      return tab_headings.on('click', function() {
        tab_headings.removeClass('active');
        tab_content.removeClass('active');
        $(this).addClass('active');
        tab_content.eq($(this).index()).addClass('active');
        if (general_scroll_to_active_item) {
          if (matchMedia('only screen and (min-width: ' + mq_small + 'px)').matches || $("html").hasClass("lt-ie9")) {
            return $('html, body').animate({
              scrollTop: tab_wrapper.offset().top - 50
            }, 'slow');
          } else {
            return $('html, body').animate({
              scrollTop: tab_wrapper.offset().top + tab_wrapper.find('.headings').outerHeight() - 50
            }, 'slow');
          }
        }
      });
    });
    }
    var ugAtcGoMode = false;
    var ugAtcAddLabel = null;
    var ugAtcGoLabel = 'Go To Cart';
    var ugCartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root + 'cart' : '/cart';
    var ugCartProductIds = {};
    var ugCartVariantIds = {};
    var ugGetAtcSubmits;
    var ugCaptureAtcLabels;
    var ugSetAtcGoMode;
    var ugRefreshCartState;
    var ugGetPageProductId;
    var ugIsCurrentProductInCart;
    var ugSyncAtcFromCart;
    var ugNoteCartLineAdded;
    var ugPurchasedVariantIds = {};
    var ugPurchasedProductIds = {};
    var ugGetFormVariantId;
    var ugIsPurchasedDuplicate;
    var ugConfirmIfPurchasedDuplicate;

    if (window.UG_PURCHASED) {
      (window.UG_PURCHASED.variantIds || []).forEach(function(id) {
        var vid = parseInt(id, 10);
        if (isFinite(vid)) {
          ugPurchasedVariantIds[vid] = true;
        }
      });
      (window.UG_PURCHASED.productIds || []).forEach(function(id) {
        var pid = parseInt(id, 10);
        if (isFinite(pid)) {
          ugPurchasedProductIds[pid] = true;
        }
      });
    }

    if (window.UG_ATC_LABELS) {
      ugAtcAddLabel = window.UG_ATC_LABELS.add || ugAtcAddLabel;
      ugAtcGoLabel = window.UG_ATC_LABELS.goToCart || ugAtcGoLabel;
    }

    ugGetAtcSubmits = function() {
      return $('.cart-form').find('input[type="submit"][name="add"], button[type="submit"][name="add"]').add(
        $('button.purchase.button[form][name="add"], input.purchase.button[form][name="add"]')
      );
    };

    ugCaptureAtcLabels = function() {
      if (!ugAtcAddLabel) {
        var $first = ugGetAtcSubmits().first();
        if ($first.length) {
          ugAtcAddLabel = $first.is('input') ? $first.val() : $.trim($first.text());
        }
      }
      if (!ugAtcAddLabel) {
        ugAtcAddLabel = 'Add to Cart';
      }
      if (window.UG_ATC_LABELS) {
        ugAtcAddLabel = window.UG_ATC_LABELS.add || ugAtcAddLabel;
        ugAtcGoLabel = window.UG_ATC_LABELS.goToCart || ugAtcGoLabel;
      }
    };

    ugSetAtcGoMode = function(on) {
      ugCaptureAtcLabels();
      ugAtcGoMode = !!on;
      $('.cart-form').each(function() {
        $(this).data('ugAtcGoMode', ugAtcGoMode);
      });
      ugGetAtcSubmits().each(function() {
        var $el = $(this);
        if (on) {
          if ($el.is('input')) {
            $el.val(ugAtcGoLabel);
          } else {
            $el.text(ugAtcGoLabel);
          }
          $el.addClass('ug-atc--go-to-cart').attr('aria-label', ugAtcGoLabel);
        } else {
          if ($el.is('input')) {
            $el.val(ugAtcAddLabel);
          } else {
            $el.text(ugAtcAddLabel);
          }
          $el.removeClass('ug-atc--go-to-cart').attr('aria-label', ugAtcAddLabel);
        }
      });
    };
    window.ugSetAtcGoMode = ugSetAtcGoMode;

    ugRefreshCartState = function(callback) {
      return $.getJSON('/cart.js', function(cart) {
        ugCartProductIds = {};
        ugCartVariantIds = {};
        if (cart && cart.items && cart.items.length) {
          cart.items.forEach(function(item) {
            if (item.product_id) {
              ugCartProductIds[item.product_id] = true;
            }
            if (item.variant_id) {
              ugCartVariantIds[item.variant_id] = true;
            }
          });
        }
        $(document).trigger('ug:cart-state-updated');
        if (callback) {
          callback(cart);
        }
      }).fail(function() {
        if (callback) {
          callback(null);
        }
      });
    };

    ugGetPageProductId = function() {
      var $article = $('article.product-content[data-product-id]').first();
      if ($article.length) {
        var id = parseInt($article.attr('data-product-id'), 10);
        return isFinite(id) ? id : null;
      }
      return null;
    };

    ugIsCurrentProductInCart = function() {
      var pid = ugGetPageProductId();
      if (!pid) {
        return false;
      }
      return !!ugCartProductIds[pid];
    };

    ugSyncAtcFromCart = function() {
      ugSetAtcGoMode(ugIsCurrentProductInCart());
    };

    ugNoteCartLineAdded = function(lineItem) {
      if (!lineItem) {
        return;
      }
      if (lineItem.product_id) {
        ugCartProductIds[lineItem.product_id] = true;
      }
      var variantId = lineItem.variant_id || lineItem.id;
      if (variantId) {
        ugCartVariantIds[variantId] = true;
      }
    };

    window.ugRefreshCartState = ugRefreshCartState;
    window.ugSyncAtcFromCart = ugSyncAtcFromCart;
    window.ugNoteCartLineAdded = ugNoteCartLineAdded;
    window.ugIsProductInCart = function(productId) {
      return !!ugCartProductIds[parseInt(productId, 10)];
    };
    window.ugIsVariantInCart = function(variantId) {
      return !!ugCartVariantIds[parseInt(variantId, 10)];
    };

    ugGetFormVariantId = function($form) {
      var $field = $form.find('select[name="id"], input[name="id"]').first();
      if (!$field.length) {
        return null;
      }
      var variantId = parseInt($field.val(), 10);
      return isFinite(variantId) ? variantId : null;
    };

    ugIsPurchasedDuplicate = function(variantId, productId) {
      if (!window.UG_PURCHASED) {
        return false;
      }
      variantId = parseInt(variantId, 10);
      if (isFinite(variantId) && ugPurchasedVariantIds[variantId]) {
        return true;
      }
      productId = productId != null ? parseInt(productId, 10) : ugGetPageProductId();
      if (isFinite(productId) && ugPurchasedProductIds[productId]) {
        return true;
      }
      return false;
    };

    ugConfirmIfPurchasedDuplicate = function(variantId, productId) {
      if (!ugIsPurchasedDuplicate(variantId, productId)) {
        return true;
      }
      var message = (window.UG_PURCHASED && window.UG_PURCHASED.confirmMessage) ||
        'You have already purchased this product. Add it to your cart again anyway?';
      return window.confirm(message);
    };

    window.ugConfirmIfPurchasedDuplicate = ugConfirmIfPurchasedDuplicate;
    window.ugIsPurchasedDuplicate = ugIsPurchasedDuplicate;

    $(document).on('change', '.cart-form select, .cart-form input[name="id"]', function() {
      ugSyncAtcFromCart();
    });

    if ($('article.product-content[data-product-id]').length && $('.cart-form').length) {
      ugRefreshCartState(ugSyncAtcFromCart);
    }

    $(document).on('submit', '.cart-form', function() {
      var $form = $(this);
      if ($form.data('ugAtcGoMode')) {
        window.location.href = ugCartUrl;
        return false;
      }
      if (!validateSize($form)) {
        return false;
      }
      if (!ugConfirmIfPurchasedDuplicate(ugGetFormVariantId($form), ugGetPageProductId())) {
        return false;
      }
      addToCart($form);
      return false;
    });

    $(document).on('click', '[data-ug-upsell-add]', function (e) {
      e.preventDefault();
      var $btn = $(this);
      if ($btn.data('ugBusy')) { return false; }
      var variantId = $btn.attr('data-variant-id');
      if (!variantId) { return false; }
      $btn.data('ugBusy', true).prop('disabled', true).addClass('is-loading');
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: { id: variantId, quantity: 1 },
        success: function () { window.location.href = '/cart'; },
        error: function () {
          // Fallback to a native add (GET redirects back to the cart).
          window.location.href = '/cart/add?id=' + encodeURIComponent(variantId) + '&quantity=1';
        }
      });
      return false;
    });

    var $mobileCartToast = null;
    var $mobileCartMask = null;
    var mobileCartPortalized = false;

    function getMobileCartEls() {
      if (!$mobileCartToast || !$mobileCartToast.length) {
        $mobileCartToast = $('.main-header .recently-added.mobile');
      }
      if (!$mobileCartMask || !$mobileCartMask.length) {
        $mobileCartMask = $('.main-header .recently-added-mask');
      }
      return { toast: $mobileCartToast, mask: $mobileCartMask };
    }

    function isMobileCartView() {
      return window.matchMedia('only screen and (max-width: ' + (mq_small - 1) + 'px)').matches;
    }

    function portalMobileCartToBody() {
      var els = getMobileCartEls();
      if (!els.toast.length) {
        return;
      }
      if (!mobileCartPortalized) {
        els.mask.addClass('ug-cart-recently-added-mask');
        els.toast.addClass('ug-cart-recently-added-mobile');
        $('body').append(els.mask).append(els.toast);
        mobileCartPortalized = true;
      }
    }

    function positionMobileCartToast() {
      var els = getMobileCartEls();
      if (!els.toast.length) {
        return;
      }
      var bottomBase = 16;
      if ($('body').hasClass('ug-audio-player-open')) {
        bottomBase = 88;
      }
      els.toast.css('bottom', 'calc(' + bottomBase + 'px + env(safe-area-inset-bottom, 0px))');
    }

    $(document).on('click', '.recently-added .close, .ug-cart-recently-added-mobile .close', function(e) {
      e.preventDefault();
      return fadeOutCartDropdown();
    });
    $('.recently-added-mask').on('click', function() {
      return fadeOutCartDropdown();
    });
    cart_dropdown_timer = '';
    toggleCartDropdown = function() {
      return $('.main-header .recently-added').slideToggle('fast');
    };
    slideDownCartDropdown = function() {
      return $('.main-header .recently-added').stop(true, true).show();
    };
    openMobileModal = function() {
      portalMobileCartToBody();
      positionMobileCartToast();
      $('body').addClass('ug-cart-toast-open');
      var els = getMobileCartEls();
      els.mask.removeClass('hide').css('display', 'block');
      return els.toast.stop(true, true).css('display', 'block').hide().fadeIn(180);
    };
    fadeOutCartDropdown = function() {
      clearTimeout(cart_dropdown_timer);
      $('body').removeClass('ug-cart-toast-open');
      $('.main-header .recently-added').fadeOut('fast');
      var els = getMobileCartEls();
      els.toast.fadeOut(160);
      return els.mask.fadeOut(160, function() {
        els.mask.addClass('hide');
      });
    };
    $('.main-header .recently-added').mouseenter(function() {
      return stopResetTimer();
    });
    $('.main-header .recently-added').mouseleave(function() {
      return startTimer();
    });
    $(window).on('resize orientationchange', function() {
      if ($('body').hasClass('ug-cart-toast-open')) {
        positionMobileCartToast();
      }
    });
    startTimer = function() {
      var dismissMs = isMobileCartView() ? 14000 : 9000;
      return cart_dropdown_timer = setTimeout((function() {
        return fadeOutCartDropdown();
      }), dismissMs);
    };
    stopResetTimer = function() {
      return clearTimeout(cart_dropdown_timer);
    };
    validateSize = function(cart_form) {
      if (cart_form.find('select option:selected').is(':disabled')) {
        cart_form.find('.dropdown').effect('shake', {
          'times': 2,
          'distance': 5
        }, 400);
        return false;
      }
      return true;
    };
    addToCart = function(cart_form) {
      return $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: cart_form.serialize(),
        success: addToCartPass,
        error: addToCartFail
      });
    };
    setupCartMoneyFormat = function() {
      var currency_symbol = $('.actual-price').first().html() || $('.ug-bundle-value__current').first().html() || '';
      var digitIdx = currency_symbol.search(/\d/);
      if (digitIdx >= 0) {
        currency_symbol = $.trim(currency_symbol.slice(0, digitIdx));
      } else {
        currency_symbol = $.trim(currency_symbol);
      }
      Shopify.money_format = currency_symbol + " {{amount}}";
    };
    cartItemFromLine = function(line) {
      var image = line.image || line.featured_image && line.featured_image.url;
      return {
        image_url: image ? Shopify.resizeImage(image, 'compact') : '',
        url: line.url || '#',
        title: line.title || '',
        price_raw: line.price,
        price: Shopify.formatMoney(line.price, Shopify.money_with_currency_format)
      };
    };
    cartTotalsFromCart = function(cart) {
      var cart_total, item, _i, _len, _ref, ptype, isBundle;
      cart_total = { quantity: 0, price: 0, eligible: 0, hasBundle: false };
      _ref = cart.items;
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        item = _ref[_i];
        cart_total.quantity += item.quantity;
        cart_total.price += item.price * item.quantity;
        // Welcome discount excludes bundles — only non-bundle lines are eligible.
        // cart.js has no tags, so detect bundles by product_type/handle/title.
        ptype = (item.product_type || '').toLowerCase();
        isBundle = ptype.indexOf('bundle') !== -1
          || (item.handle || '').toLowerCase().indexOf('bundle') !== -1
          || (item.product_title || item.title || '').toLowerCase().indexOf('bundle') !== -1;
        if (isBundle) {
          cart_total.hasBundle = true;
        } else {
          cart_total.eligible += item.price * item.quantity;
        }
      }
      // Shopify's own totals: original (pre-discount) vs total_price (after any
      // applied discount, e.g. New30). We display these directly rather than
      // re-deriving a % — re-deriving double-discounted an already-discounted cart.
      cart_total.original = (typeof cart.original_total_price === 'number') ? cart.original_total_price : cart_total.price;
      cart_total.realTotal = (typeof cart.total_price === 'number') ? cart.total_price : cart_total.price;
      return cart_total;
    };
    optimisticCartTotals = function(lineItem) {
      var prevQty, addQty, lineCents;
      prevQty = parseInt($('.cart-link .number').first().text(), 10);
      if (isNaN(prevQty)) {
        prevQty = 0;
      }
      addQty = lineItem.quantity || 1;
      lineCents = lineItem.final_line_price;
      if (lineCents == null) {
        lineCents = lineItem.line_price;
      }
      if (lineCents == null) {
        lineCents = (lineItem.price || 0) * addQty;
      }
      return {
        quantity: prevQty + addQty,
        price: lineCents
      };
    };
    // Cart totals come straight from Shopify (original_total_price vs total_price),
    // so whatever discount is actually applied — New30 (applied to the cart via
    // /discount/New30) or the automatic Buy-2-Get-1 — is the REAL figure and matches
    // checkout. We deliberately do not show a client-side estimate: an earlier
    // estimate path was removed because it could disagree with checkout once both
    // the code and the automatic discount existed (they don't stack).
    var ugRenderCartTotal = function(cart_total) {
      var $tp = $('.recently-added .total-price');
      // Use Shopify's real totals: original (pre-discount) vs realTotal (after any
      // applied discount). Never re-derive a % — that double-discounts an already
      // discounted cart. The optimistic pass has neither field, so it falls back
      // to the plain line total until the /cart.js refine fills them in.
      var original = (typeof cart_total.original === 'number') ? cart_total.original : cart_total.price;
      var realTotal = (typeof cart_total.realTotal === 'number') ? cart_total.realTotal : cart_total.price;
      var realSavings = original - realTotal;
      $('.ug-cart-disc-note').remove();
      if (realSavings <= 0) {
        $tp.removeClass('ug-has-discount').html(Shopify.formatMoney(realTotal, Shopify.money_format));
        return;
      }
      var was = '<s class="ug-cart-was money">' + Shopify.formatMoney(original, Shopify.money_format) + '</s>';
      var now = '<span class="ug-cart-now money">' + Shopify.formatMoney(realTotal, Shopify.money_format) + '</span>';
      $tp.addClass('ug-has-discount').html(was + ' ' + now);
      var noteTxt = cart_total.hasBundle
        ? (Shopify.formatMoney(realSavings, Shopify.money_format) + ' off packs — bundle full price')
        : (Shopify.formatMoney(realSavings, Shopify.money_format) + ' off');
      $tp.each(function() {
        var $strong = $(this).closest('strong');
        var $host = $strong.length ? $strong : $(this);
        $host.next('.ug-cart-disc-note').remove();
        $host.after('<div class="ug-cart-disc-note">' + noteTxt + '</div>');
      });
    };
    applyCartDropdownUI = function(cart_item, cart_total) {
      var new_cart_row, new_mobile_item;
      $('.cart-link .number').html(cart_total.quantity);
      $('.cart-link .number-wrapper').removeClass('hide');
      $('.recently-added .items-count .number').html(cart_total.quantity);
      ugRenderCartTotal(cart_total);
      new_cart_row = '<tr>';
      new_cart_row += '<td class="cart-item">';
      new_cart_row += '<a href="' + cart_item.url + '">';
      new_cart_row += '<img src="' + cart_item.image_url + '" alt="' + cart_item.title + '">';
      new_cart_row += '</a>';
      new_cart_row += '</td>';
      new_cart_row += '<td class="cart-detail">';
      new_cart_row += '<h2><a href="' + cart_item.url + '">' + cart_item.title + '</a></h2>';
      new_cart_row += '</td>';
      new_cart_row += '<td class="cart-price"><span class="money">' + cart_item.price + '</span></td>';
      new_cart_row += '</tr>';
      new_mobile_item = '<a href="' + cart_item.url + '" class="ug-cart-toast-item__link">';
      new_mobile_item += '<img src="' + cart_item.image_url + '" alt="">';
      new_mobile_item += '</a>';
      new_mobile_item += '<span class="ug-cart-toast-item__title">' + cart_item.title + '</span>';
      $('.recently-added tbody').html(new_cart_row);
      $('.recently-added .mobile-item').html(new_mobile_item);
      $('.recently-added .total-price:not(.ug-has-discount)').addClass('money');
      $('.recently-added .error').hide();
      $('.recently-added table').show();
      $('.recently-added div.row').show();
    };
    showCartDropdownFeedback = function() {
      if (isMobileCartView()) {
        openMobileModal();
      } else if ($('.main-header .mobile-tools').is(':hidden')) {
        slideDownCartDropdown();
      } else {
        openMobileModal();
      }
      return startTimer();
    };
    addToCartPass = function(lineItem) {
      setupCartMoneyFormat();
      applyCartDropdownUI(cartItemFromLine(lineItem), optimisticCartTotals(lineItem));
      showCartDropdownFeedback();
      ugNoteCartLineAdded(lineItem);
      ugSyncAtcFromCart();
      return $.getJSON('/cart.js', function(cart) {
        applyCartDropdownUI(cartItemFromLine(lineItem), cartTotalsFromCart(cart));
        if (cart && cart.items && cart.items.length) {
          ugCartProductIds = {};
          ugCartVariantIds = {};
          cart.items.forEach(function(item) {
            if (item.product_id) {
              ugCartProductIds[item.product_id] = true;
            }
            if (item.variant_id) {
              ugCartVariantIds[item.variant_id] = true;
            }
          });
          $(document).trigger('ug:cart-state-updated', [cart]);
        }
        ugSyncAtcFromCart();
        if (typeof currency_switcher_enabled !== 'undefined' && currency_switcher_enabled && typeof Currency !== 'undefined' && jQuery('[name=currencies]').length) {
          Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
        }
      });
    };
    addToCartFail = function(obj, status) {
      $('.recently-added .error').show();
      $('.recently-added table').hide();
      $('.recently-added div.row').hide();
      if (isMobileCartView()) {
        openMobileModal();
      } else {
        slideDownCartDropdown();
      }
      return startTimer();
    };
    recentCartItemPopUp = function(lineItem) {
      setupCartMoneyFormat();
      if (lineItem) {
        applyCartDropdownUI(cartItemFromLine(lineItem), optimisticCartTotals(lineItem));
        showCartDropdownFeedback();
        return $.getJSON('/cart.js', function(cart) {
          applyCartDropdownUI(cartItemFromLine(lineItem), cartTotalsFromCart(cart));
          if (typeof currency_switcher_enabled !== 'undefined' && currency_switcher_enabled && typeof Currency !== 'undefined' && jQuery('[name=currencies]').length) {
            Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
          }
        });
      }
      return $.getJSON('/cart.js', function(cart) {
        var cart_item, cart_total;
        if (!cart.items.length) {
          return;
        }
        cart_item = cartItemFromLine(cart.items[cart.items.length - 1]);
        cart_total = cartTotalsFromCart(cart);
        applyCartDropdownUI(cart_item, cart_total);
        if (typeof currency_switcher_enabled !== 'undefined' && currency_switcher_enabled && typeof Currency !== 'undefined' && jQuery('[name=currencies]').length) {
          Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
        }
        showCartDropdownFeedback();
      });
    };
    window.recentCartItemPopUp = recentCartItemPopUp;
    if (Modernizr.touch === false) {
      $('.product-grid .product-item').mouseenter(function() {
        return $(this).find('.image-wrapper').animate({
          opacity: 0.5
        }, 100);
      }).mouseleave(function() {
        return $(this).find('.image-wrapper').stop(true, true).animate({
          opacity: 1
        }, 300);
      });
    }
    // Re-runnable per-page init for instant navigation (Swup). Page-scoped
    // window/document handlers use the ".ugpage" namespace and are cleared first
    // so re-running on each navigation never stacks duplicate listeners.
    window.ugThemePageInit = function ugThemePageInit() {
    $(window).off('resize.ugpage');
    $(document).off('smallWindow.ugpage mediumWindow.ugpage largeWindow.ugpage');
    current_window = '';
    ugInitContentWidgets();
    if (PAGE.hasClass('template-product') && typeof window.ugRefreshCartState === 'function' && $('.cart-form').length) {
      window.ugRefreshCartState(typeof window.ugSyncAtcFromCart === 'function' ? window.ugSyncAtcFromCart : null);
    }
    if (PAGE.hasClass('template-page')) {
      page_content = $('.page-content .rte-content');
      if (page_content.find('.left-side-column').length || page_content.find('.right-side-column').length) {
        if (page_content.find('.left-side-column').length && page_content.find('.right-side-column').length) {
          page_content.wrapInner("<div class='main-column with-2-sidebars'></div>");
          $('.left-side-column').addClass('with-2-sidebars');
          $('.right-side-column').addClass('with-2-sidebars');
        } else {
          page_content.wrapInner("<div class='main-column'></div>");
        }
        $('.left-side-column').prependTo(page_content);
        $('.right-side-column').appendTo(page_content);
      }
    }
    if (PAGE.hasClass('template-index')) {
      FullscreenSlider = (function() {
        function FullscreenSlider(slider_element, autoplay_enabled, autoplay_frequency) {
          this.eventListeners = __bind(this.eventListeners, this);
          this.alignPlayButton = __bind(this.alignPlayButton, this);
          this.alignCaption = __bind(this.alignCaption, this);
          this.getActiveIndex = __bind(this.getActiveIndex, this);
          this.autoplay = __bind(this.autoplay, this);
          this.createSlider = __bind(this.createSlider, this);
          this.el = slider_element;
          this.autoplay_enabled = autoplay_enabled;
          this.autoplay_frequency = autoplay_frequency;
          this.createSlider();
          this.owl = $(".owl-carousel").data('owlCarousel');
        }

        FullscreenSlider.prototype.createSlider = function() {
          var slider;
          slider = this;
          slider.el.css('opacity', 1);
          return slider.el.owlCarousel({
            singleItem: true,
            navigation: false,
            paginationNumbers: false,
            scrollPerPageNav: true,
            slideSpeed: 800,
            pagination: true,
            autoHeight: true,
            autoPlay: slider.autoplay(),
            afterInit: function() {
              slider.el.css('opacity', 1);
              return slider.eventListeners();
            },
            afterAction: function() {
              slider.alignCaption();
              return slider.alignPlayButton();
            }
          });
        };

        FullscreenSlider.prototype.autoplay = function() {
          if (this.autoplay_enabled) {
            return this.autoplay_frequency;
          }
          return false;
        };

        FullscreenSlider.prototype.getActiveIndex = function() {
          return this.el.find('.owl-pagination .owl-page.active').index();
        };

        FullscreenSlider.prototype.alignCaption = function() {
          var caption, caption_height, caption_width, slide, slide_padding, top_offset;
          slide = this.el.find('.owl-item').eq(this.getActiveIndex());
          caption = slide.find('.caption');
          caption.css('visibility', 'hidden');
          caption_height = caption.outerHeight();
          caption_width = caption.outerWidth();
          slide_padding = 30;
          if (PAGE.hasClass('transparent-menu')) {
            top_offset = $('.main-header').outerHeight();
          } else {
            top_offset = 0;
          }
          return slide.find('img').first().imagesLoaded(function() {
            var left_offset, middle_top, slide_height, slide_width;
            slide_height = slide.outerHeight();
            slide_width = slide.outerWidth();
            if (caption.hasClass('top')) {
              caption.css('top', top_offset + slide_padding);
            } else if (caption.hasClass('middle')) {
              middle_top = top_offset + (slide_height - top_offset - caption_height) / 2;
              caption.css('top', middle_top);
            }
            if (caption.hasClass('center')) {
              left_offset = (slide_width - caption_width) / 2;
              caption.css('left', left_offset);
            }
            return caption.css('visibility', 'visible');
          });
        };

        FullscreenSlider.prototype.alignPlayButton = function() {
          var play_button, slide;
          slide = this.el.find('.owl-item').eq(this.getActiveIndex());
          play_button = slide.find('.play-button');
          play_button.css('visibility', 'hidden');
          if (PAGE.hasClass('transparent-menu') && $('.main-header').css('position') === 'absolute') {
            slide.find('img').first().imagesLoaded(function() {
              var play_button_height, slide_height, video_offset;
              slide_height = slide.outerHeight();
              play_button_height = play_button.outerHeight();
              video_offset = (slide_height - play_button_height) / 2;
              return play_button.css({
                'margin-top': 0,
                'top': video_offset
              });
            });
          } else {
            play_button.css({
              'margin-top': '-40px',
              'top': '50%'
            });
          }
          return play_button.css('visibility', 'visible');
        };

        FullscreenSlider.prototype.eventListeners = function() {
          var slider;
          slider = this;
          this.el.find(".play-button").on('click', function() {
            var video_modal;
            video_modal = new VideoModal($(this).closest('.video'));
            video_modal.open();
            slider.owl.stop();
            return false;
          });
          return this.el.find('.owl-pagination .owl-page').on('click', function() {
            return slider.owl.stop();
          });
        };

        return FullscreenSlider;

      })();
      fullscreen_slider = new FullscreenSlider($('.slider .slides'), home_slider_auto_enabled, home_slider_rotate_frequency);
      productSlider = function() {
        $('.product-slider').slice(1).css('padding-top', 0);
        return $('.product-slider').each(function() {
          $(this).find('.product-grid').owlCarousel({
            items: 4,
            navigation: true,
            scrollPerPage: true,
            slideSpeed: 800,
            lazyLoad: true,
            pagination: false,
            navigationText: false
          });
          return $(this).find('.product-item').show();
        });
      };
      productSlider();
      $(window).on('resize.ugpage', function() {
        return productSlider();
      });
      smallPromos = function() {
        return $('.small-promos .image-text-widget').mouseenter(function() {
          return $(this).find('.caption').fadeIn(300);
        }).mouseleave(function() {
          return $(this).find('.caption').stop(true, true).fadeOut(300);
        });
      };
      smallPromos();
      instagramFeed();
    }
    if (PAGE.hasClass('template-list-collections')) {
      $('.collection-item').mouseenter(function() {
        return $(this).find('.caption').fadeIn(300);
      }).mouseleave(function() {
        return $(this).find('.caption').stop(true, true).fadeOut(300);
      });
    }
    if (PAGE.hasClass('template-product')) {
      positions = function() {
        var insertPosition;
        insertPosition = function(position_target) {
          var positions_src, target;

          positions_src = $('.positions.active');
          target = position_target;

          positions_src.find('[data-position]').each(function () {
            var elem_src, elem_target, position;
            position = $(this).attr('data-position');
            if (position.length) {
              elem_src = positions_src.find('[data-position="' + position + '"]');
              elem_target = target.find('[data-position="' + position + '"]');
              return elem_src.children().appendTo(elem_target);
            }
          });
          positions_src.removeClass('active');
          return position_target.addClass('active');
        };
        $(document).on("smallWindow.ugpage", function() {
          return insertPosition($('.positions.show-for-small'));
        });
        $(document).on("mediumWindow.ugpage", function() {
          return insertPosition($('.positions.show-for-medium-only'));
        });
        $(document).on("largeWindow.ugpage", function() {
          return insertPosition($('.positions.show-for-large-up'));
        });
      };
      positions();
      photos = $('article .photos');
      thumbs = $('article .thumbs');
      photos.on('click', function(e) {
        if ($(e.target).closest('.ug-audio-play-trigger').length) {
          return;
        }
        return false;
      });

      imgZoom = function(index) {
        if (Modernizr.touch === false && product_zoom_enabled) {
          return photos.find('.container').zoom({
            url: photos.find('.photo').eq(index).attr('data-zoom')
          });
        }
      };
      if (Modernizr.touch === false && product_zoom_enabled) {
        photos.find('.container').on("mouseover", function() {
          $(this).css('outline-width', 1);
          return photos.find('.zoomImg').css({
            opacity: 1
          });
        }).on("mouseleave", function() {
          return $(this).css('outline-width', 0);
        });
      }
      updateActiveImg = function(index) {
        var transition_time;
        if (photos.find('.photo').eq(index).find('img').length < 1) {
          return;
        }
        if (photos.find('.photo.active').index() === index) {
          return;
        }
        thumbs.find('.thumb').removeClass('active');
        thumbs.find('.thumb').eq(index).addClass('active');
        photos.find('.zoomImg').remove();
        transition_time = 0;
        if (photos.find('.photo.active').length) {
          transition_time = 300;
          photos.find('.photo.active').fadeOut(transition_time).removeClass('active');
        }
        photos.find('.photo').eq(index).delay(transition_time).imagesLoaded(function() {
          var container_width, height, width;
          imgZoom(index);
          height = photos.find('.photo').eq(index).find('img').naturalHeight();
          width = photos.find('.photo').eq(index).find('img').naturalWidth();
          container_width = photos.outerWidth();
          if (container_width < width) {
            height = container_width / width * height;
            width = container_width;
          }
          photos.find('.container').animate({
            "height": height,
            "width": width
          }, transition_time, function() {
            return photos.find('.container').css({
              'height': 'auto',
              'width': 'auto'
            });
          });
          return photos.find('.photo').eq(index).addClass('active').fadeIn(transition_time);
        });
      };
      thumbs.find('.thumb').click(function() {
        return updateActiveImg($(this).index());
      });
      theme.variantSelected = function(variant, selector) {
        var actual_price, compare_price, variant_image_index;
        $(".compare-price").html("");
        if (variant && variant.available) {
          $(".quantity-cart-row").show();
          $('.product-unavailable').hide();
        } else {
          $(".quantity-cart-row").hide();
          $('.product-unavailable').show();
          if (product_variant_size > 1 && variant) {
            $('.product-unavailable form .email-body').attr('value', 'Please notify me when this is back in stock: ' + product_title + ' - ' + variant.title);
          }
        }
        if (variant) {
          actual_price = Shopify.formatMoney(variant.price, shop_money_format);
          $(".actual-price").replaceWith('<span class="actual-price money" itemprop="price">' + actual_price + '</span>');
          if (variant.compare_at_price > variant.price) {
            compare_price = Shopify.formatMoney(variant.compare_at_price, shop_money_format);
            $(".compare-price").html(product_language_was + '<span class="money">' + compare_price + '</span>');
            var ugSavePct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
            $("[data-ug-save-badge]").text('-' + ugSavePct + '%').show();
          } else {
            $("[data-ug-save-badge]").hide();
          }
          if (typeof currency_switcher_enabled !== 'undefined' && currency_switcher_enabled && typeof Currency !== 'undefined' && jQuery('[name=currencies]').length) {
            Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
          }
          if (variant.featured_image) {
            variant_image_index = $('article .photos .photo[data-image-id="' + variant.featured_image.id + '"]').index();
            updateActiveImg(variant_image_index);
          } else {
            updateActiveImg(0);
          }
        }
        if (typeof ugSyncAtcFromCart === 'function') {
          ugSyncAtcFromCart();
        }
      };
      // end of selectCallback;
      if (product_options_size === 1 && product_options_first !== "Title") {
        $(".selector-wrapper:eq(0)").prepend("<label>" + product_options_first + "</label>");
      }
      $(".selector-wrapper .single-option-selector").each(Foundation.libs.forms.append_custom_select);
      $("select.single-option-selector").change(function() {
        Foundation.libs.forms.refresh_custom_select($(this), true);
      });
      productModal();
    }
    if (PAGE.hasClass('template-article')) {
      pinterest_button = $('.social-share .pinterest');
      first_article_img = $('.article img').first().attr('src');
      pinterest_button.attr('href', pinterest_button.attr('href') + '&media=' + first_article_img);
    }
    isFirefox = typeof InstallTrigger !== "undefined";
    if (isFirefox) {
      $('img').addClass('image-scale-hack');
    }
    if (Modernizr.touch) {
      $("form.custom .hidden-field").removeClass('hidden-field');
    }
    current_window = '';
    mediaQueries = function() {
      if ($("html").hasClass("lt-ie9")) {
        $.event.trigger("mediumWindow");
        return current_window = 'medium';
      } else if (window.matchMedia('only screen and (min-width: ' + mq_medium + 'px)').matches) {
        if (current_window !== 'large') {
          $.event.trigger("largeWindow");
          return current_window = 'large';
        }
      } else if (window.matchMedia('only screen and (min-width: ' + mq_small + 'px)').matches) {
        if (current_window !== 'medium') {
          $.event.trigger("mediumWindow");
          return current_window = 'medium';
        }
      } else {
        if (current_window !== 'small') {
          $.event.trigger("smallWindow");
          return current_window = 'small';
        }
      }
    };
    mediaQueries();
    $(window).on('resize.ugpage', function() {
      return mediaQueries();
    });

    resizeBanners = function () {
      setTimeout(() => {
        const slider = $('.owl-wrapper-outer');
        const offers = $('.offers');
        const charts = $('.charts');
        if (!slider || $(offers).is(":hidden")) {
          return;
        }
        const slideHeight = slider.height();
        offers.css('height', `${slideHeight}px`);
        charts.css('height', `${slideHeight}px`);
      }, 600);

    }
    resizeBanners();
    $(window).on('resize.ugpage', function () {
        resizeBanners();
    });

    $('.hide-until-js').show();
    };
    ugThemePageInit();
    return true;
  });

  return false;

}).call(this);
